import {
  CareersHeroSection,
  GetInTouchFiledSection,
  NormalBrowseFileInputFiled,
  NormalTextInputField,
} from "@/components";
import { useMemo } from "react";

const CareersCMSForm = ({
  activeTab,
  isFetching,
  formData,
  selectedTab,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  handleImageChange,
  adminRole,
  permissionsList,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeTab === "en" ? true : false;
  }, [activeTab]);

  return (
    <>
      {selectedTab === "section-1" && (
        <>
          {/* Banner Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Banner Image"
              fieldId="career-banner-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange("career-banner-image", id)
                  : handleImageChange("career-banner-image", "")
              }
              selectedFileId={formData?.["career-banner-image"] || ""}
              adminRole={adminRole}
              permissionsList={permissionsList}
              infoText="Recommended size: 1300 x 650px"
            />
          )}

          {/* Banner Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Banner Heading"
            fieldId="career-banner-heading"
            fieldName="career-banner-heading"
            placeholderText="Banner Heading"
            inputValue={formData?.["career-banner-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Banner Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Banner Description"
            fieldId="career-banner-description"
            fieldName="career-banner-description"
            placeholderText="Banner Description"
            inputValue={formData?.["career-banner-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Page Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Page Heading"
            fieldId="career-heading"
            fieldName="career-heading"
            placeholderText="Page Heading"
            inputValue={formData?.["career-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Page Sub Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Page Sub Heading"
            fieldId="career-sub-heading"
            fieldName="career-sub-heading"
            placeholderText="Page Sub Heading"
            inputValue={formData?.["career-sub-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />
        </>
      )}
    </>
  );
};

export default CareersCMSForm;
